export default __webpack_public_path__ + "static/media/2.8ae8c900.png";